import getCountryFromUrl from '@PayseraServiceAgreementBundle/Resources/assets/js/service/getCountryFromUrl';

export const getPrivacyPolicyLink = () => {
    const LT_COUNTRY_LINK = 'https://www.paysera.lt/v2/lt-LT/sutartys/pranesimas-apie-kandidatu-asmens-duomenu-tvarkyma';
    const ALL_COUNTRY_LINK = 'https://www.paysera.com/v2/en-GB/legal/notice-on-candidates-personal-data-processing';

    return getCountryFromUrl() === 'LT' ? LT_COUNTRY_LINK : ALL_COUNTRY_LINK
};
